import { useParams } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Table, Modal, ModalBody, ModalFooter } from 'reactstrap';
import React from 'react';
import Translate, { t } from '../common/Translate';
import { useGuaranteeHistory } from '../../hooks/useGuaranteedPrice/useGuaranteeHistory';

function HistoryGaranteedModal({ isOpen, toggle }) {
  const { recordId } = useParams();
  const { historyResponse, formatMessage } = useGuaranteeHistory(recordId);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="modal-lg">
      <ModalBody className="pb-0">
        <h2>{t('historyRequestedGuaranteedPrice')}</h2>
        <Table hover responsive="sm">
          <thead>
            <tr>
              <td>{t('dateAndHour')}</td>
              <td>{t('userInfos')}</td>
              <td>{t('guaranteedPriceMessage')}</td>
            </tr>
          </thead>
          <tbody>
            {historyResponse &&
              historyResponse.map(({ id, createdAt, userFullName, message, nrmStatusId }) => (
                <tr key={id}>
                  <td className="border-dark border-bottom">{moment(createdAt).format('DD-MM-YYYY HH:mm:ss')}</td>
                  <td className="border-dark border-bottom">{userFullName === 'Robot' ? t('robot') : userFullName}</td>
                  <td className="border-dark border-bottom">
                    <div>{nrmStatusId && nrmStatusId === 1 && t('guaranteedPriceRequested')}</div>

                    {message !== null &&
                      formatMessage(message).map((elt) => {
                        return (
                          <>
                            <span>
                              {Object.keys(elt)} : {Object.values(elt)}
                            </span>
                            <br />
                          </>
                        );
                      })}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-1" onClick={toggle}>
          <Translate code="close" />
        </button>
      </ModalFooter>
    </Modal>
  );
}
HistoryGaranteedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default HistoryGaranteedModal;
